<template>
<!-- data-wow-duration="1s" data-wow-delay="0s"  wow slideInDown-->
  <header class=""> 
    <div class="container-fluid">
      <div class="row justify-content-between">
        <div class="col-lg-4 col-md-12">
          <a class="logo" href="/#"><img src="/theme/img/logo.svg" /></a>
          <a class="mobile-navicon" href="#"  v-on:click.stop.prevent="isShow = !isShow"><i class="ico-menu"></i></a>
        </div>
        <div class="col-md-8">
          <transition name="slide">
            <ul class="top-menu" :class="(isShow)?'shown':''">
                <li><router-link to="/#" exact-path >Home</router-link></li>
                <li><router-link to="/#about">About</router-link></li>
                <li><a target="_blank" href="https://blog.alphaq.ai/">Blog</a></li>
                <li><a href="/contact">Contact</a> </li>
            </ul>
          </transition>
        </div>
      </div>
    </div>
  </header>
</template>
<script>
// @click="scrollTo('about')"
import helpers from '@/plugins/helpers' 
export default {
  data() {
    return {
      isShow:true,
      moveId:""
    }
  },
  mounted () {
    if ( helpers.isMobile()) this.isShow =false;
  },

  methods: {

  },
  watch:{
    $route(to, from){
      this.isShow=false
  }
}
}

</script>
